export const getFieldInfo = (searchField, technologyListFields) => {
  
  
  let fieldFound = {};
  technologyListFields.forEach((element) => {
    
    if (element.field === searchField) {
      fieldFound = element;
    }
  });
  return fieldFound;
}